import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import {useFetch} from '../../../utils/hooks/useFetch'
import { Spin, message, Modal, Tabs, Typography } from 'antd';
import SkillWikiModal from '../wiki/SkillWikiModal';
import { skillsToChoseColumns, skillsToChoseList } from '../columns/skillColumns';
import LarpTable from '../../table/LarpTable';

export default function SkillsToChoseSl({
    allRaces,
    newCharacter,
    isModalVisible, 
    setIsModalVisible,
    addSkillToCharacter
}) {

     const [appState] = useContext(appContext);
     const [doFetch, FetchType] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([])
     const [result, setResult] = useState([])
     const [isSLViewModalVisible, setIsSLViewModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState({});

      useEffect(() => {
        if(result.length <= 0) {
          setDataSource([])
          setListSource([])
          return;
        }
        const newDataSource = result.filter(_ => _.name?.toLowerCase().includes(searchValue.toLowerCase())
                                                ||  _.skillPointType?.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
        setDataSource(newDataSource);
        setListSource(skillsToChoseList(newDataSource, appState, onAddClick, onRowClick))
      }, // eslint-disable-next-line
      [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue, appState.storyId, newCharacter])

      function refresh()
      {

          const url = `/api/Skill/GetAll`
          doFetch(url, FetchType.GET)
            .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
          function onInventoryLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get Skills');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsModalVisible(true);
      }

      function onAddClick(record) {
          setIsModalVisible(false);
          addSkillToCharacter(record);
      }
      
      const columns = skillsToChoseColumns(appState, onAddClick, onRowClick);

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    return (
        <Modal 
            title={`SL Skill to add`}  
            visible={isModalVisible} 
            onOk={handleOk} 
            onCancel={handleCancel}
            footer={null}
            width={"80%"}
        >
            <LarpTable 
                columns={columns}
                dataSource={dataSource}
                listSource={listSource}
                onDoubleRowClick={onRowClick}
                refresh={refresh}
                setSearchValue={setSearchValue}
            />

            <SkillWikiModal 
                setIsModalVisible={setIsSLViewModalVisible}
                isModalVisible={isSLViewModalVisible}
                record={selectedRecord}
                allSkills={dataSource}
                allRaces={allRaces}
            />     
    </Modal>
    )
}